// Open/close focus-lifecycle side effect for AppDialog. Called from inside
// the dialog's own `isOpen` reactive prop factory — the same
// side-effect-inside-a-reactive-prop technique already proven in
// packages/shared/components/Modal.js's `_syncUrl` (called from `Modal`'s
// `isOpen` prop). Per-element state only (`el._wasOpen` / `el._returnFocusTo`
// on `this`), no module-level singleton: AppDialog's Escape handling is
// per-instance (bubbling `onKeydown` on the dialog root), not a shared
// global listener, so there's nothing to coordinate across instances here.
export function appDialogSync(open) {
  const el = this
  if (typeof document === 'undefined') return
  if (open === el._wasOpen) return
  el._wasOpen = open
  if (open) {
    el._returnFocusTo = document.activeElement
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => el.call('appDialogFocusPanel'))
    } else {
      el.call('appDialogFocusPanel')
    }
  } else {
    if (el._returnFocusTo && el._returnFocusTo.focus) el._returnFocusTo.focus()
    el._returnFocusTo = null
  }
}
